/* PopUpComponent.js */

"use strict";
const _ = require("lodash");
const InputBaseControl = require("@gluenetworks/input_base_control").Base;
const Renderer = require("./PopUpRenderer");

class PopUpComponent extends InputBaseControl {
    constructor(config) {
        if (!_.isBoolean(config.visible)) {
            config.visible = false; // hide by default
        }
        super(config);
        this._anchorPoints = [
            "center",
            "top",
            "topRight",
            "right",
            "bottomRight",
            "bottom",
            "bottomLeft",
            "left",
            "topLeft",
        ];
        this._anchorPoint = _.get(config, "anchorPoint", "topRight");
        this._displayDirections = [
            "top",
            "topRight",
            "right",
            "bottomRight",
            "bottom",
            "bottomLeft",
            "left",
            "topLeft",
        ];
        this._displayDirection = _.get(config, "displayDirection", "topRight");
        this._hideDelayTime = _.get(config, "hideDelayTime", 0);
        this._anchor = _.get(config, "anchor", undefined);
        this._parent = _.get(config, "parent", undefined);
        this._content = _.get(config, "content", undefined);
        this._confirmPopupFunc = _.get(config, "confirmPopupFunc", undefined);
        this._allowClickInside = _.get(config, "allowClickInside", false);
        this._openOnHover = _.get(config, "openOnHover", false);
        if (!this._parent && this._content.parentNode) {
            this._parent = this._content.parentNode;
        }
        this._registerListeners();
        this._renderer = new Renderer(this);
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get parent() {
        return this.getParent();
    }

    set parent(newParent) {
        return this.setParent(newParent);
    }

    getParent() {
        return this._parent;
    }

    setParent(newParent) {
        this._parent = newParent;
        this.emit("Parent", this._parent);
        return this;
    }

    get showOn() {
        return this.getShowOn();
    }

    set showOn(eventName) {
        return this.setShowOn(eventName);
    }

    getShowOn() {
        return this._showOn;
    }

    setShowOn(eventName) {
        this._showOn = eventName;
        return this;
    }

    get hideDelayTime() {
        return this.getHideDelayTime();
    }

    set hideDelayTime(ms) {
        return this.setHideDelayTime(ms);
    }

    getHideDelayTime() {
        return this._hideDelayTime;
    }

    setHideDelayTime(ms) {
        this._hideDelayTime = ms;
        return this;
    }

    get displayDirection() {
        return this.getDisplayDirection();
    }

    set displayDirection(dir) {
        return this.setDisplayDirection(dir);
    }

    getDisplayDirection() {
        return this._displayDirection;
    }

    setDisplayDirection(dir) {
        if (this._displayDirections.includes(dir)) {
            this._displayDirection = dir;
        }
        this.emit("DisplayDirection");
        return this;
    }

    get displayDirections() {
        return this.getDisplayDirections();
    }

    getDisplayDirections() {
        return this._displayDirections;
    }

    get anchorPoint() {
        return this.getAnchorPoint();
    }

    set anchorPoint(point) {
        return this.setAnchorPoint(point);
    }

    getAnchorPoint() {
        return this._anchorPoint;
    }

    setAnchorPoint(point) {
        if (this._anchorPoints.includes(point)) {
            this._anchorPoint = point;
            this.emit("AnchorPoint");
        }
        return this;
    }

    get anchorPoints() {
        return this.getAnchorPoints();
    }

    getAnchorPoints() {
        return this._anchorPoints;
    }

    get anchor() {
        return this.getAnchor();
    }

    set anchor(elem) {
        return this.setAnchor(elem);
    }

    getAnchor() {
        return this._anchor;
    }

    setAnchor(elem) {
        this._anchor = elem;
        this.emit("Anchor");
        return this;
    }

    get content() {
        return this.getContent();
    }

    set content(component) {
        return this.setContent(component);
    }

    getContent() {
        return this._content;
    }

    setContent(newContent) {
        this._content = newContent;
        this.emit("Content");
        return this;
    }

    get confirmPopupFunc() {
        return this.getConfirmPopupFunc();
    }

    set confirmPopupFunc(confirmPopupFunc) {
        return this.setConfirmPopupFunc(confirmPopupFunc);
    }

    getConfirmPopupFunc() {
        return this._confirmPopupFunc;
    }

    setConfirmPopupFunc(confirmPopupFunc) {
        this._confirmPopupFunc = confirmPopupFunc;
    }

    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer.shutdown().then(() => {
            this._renderer = undefined;
        });
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = PopUpComponent;
